var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBitbucket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.43 28.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_bitbucket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59,10.52h0a1,1,0,0,0-1,1,.86.86,0,0,0,0,.16l4.28,26a1.37,1.37,0,0,0,1.34,1.15H34.7a1,1,0,0,0,1-.85L40,11.7a.92.92,0,0,0,0-.16,1,1,0,0,0-1-1H9.59Zm18,18.76H21L19.27,20h9.91Z",
    transform: "translate(-8.57 -10.52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.63,20H29.18l-1.59,9.26H21l-7.73,9.18a1.38,1.38,0,0,0,.89.33H34.71a1,1,0,0,0,1-.85Z",
    transform: "translate(-8.57 -10.52)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBitbucket);
export default __webpack_public_path__ + "static/media/ic_bitbucket.6790bf8f20a3369a8f362c4ea2b73077.svg";
export { ForwardRef as ReactComponent };